import React from "react";
import fs from "fs";
import matter from "gray-matter";
import Link from "next/link";
import MutedText from "@components/Various/MutedText";
import Image from "next/legacy/image";
import Head from "next/head";
import { Card } from "@mantine/core";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

function BlogIndex({ posts }: { posts: { slug: string; frontmatter: any }[] }) {
  return (
    <div className="p-12">
      <Head>
        <title>Smarketer Jobs | Blog</title>
      </Head>

      <h1 className="text-3xl font-bold pb-8 flex flex-col md:flex-row items-start md:items-center gap-3">
        Blog
      </h1>

      <MutedText>
        Erfahre mehr über die neuesten Trends und Entwicklungen im Bereich
        Personalmarketing.
      </MutedText>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4 md:p-0 mt-6">
        {posts.map(({ slug, frontmatter }) => (
          <Link href={`/blog/posts/${slug}`} key={slug} legacyBehavior>
            <Card className="cursor-pointer">
              <Card.Section>
                <div className="h-64 overflow-y-hidden w-full relative">
                  <Image
                    alt={frontmatter.title}
                    src={frontmatter.socialImage}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
              </Card.Section>

              <h1 className="text-black text-2xl font-bold mt-6">
                {frontmatter.title}
              </h1>
              <p className="text-sm font-medium text-slate-400 mt-3">
                Veröffentlicht am {frontmatter.date}
              </p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}

export async function getStaticProps({ locale }: { locale: string }) {
  const files = fs.readdirSync("posts");
  const posts = files.map((fileName) => {
    const slug = fileName.replace(".md", "");
    const readFile = fs.readFileSync(`posts/${fileName}`, "utf-8");
    const { data: frontmatter } = matter(readFile);

    return {
      slug,
      frontmatter,
    };
  });
  return await {
    props: {
      posts,
      ...(await serverSideTranslations(locale!)),
    },
  };
}

export default BlogIndex;
